// extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__z7Tz7","select__arrow":"CustomSelect_select__arrow__cm3rU"};